import { injectIntl as withIntl } from 'react-intl';

export default withIntl;
